import { MagazineContextProvider } from '@/contexts/Magazine/Magazine.context';
import { BreakPoint } from '@/hooks/useBreakPoint/consts';
import { PREVENT_DISMISS_PROP } from '@/hooks/useHeader/consts';
import useIsMobile from '@/hooks/useIsMobile/useIsMobile';
import Button from '@uikit/components/Button/Button';
import {
  ButtonColor,
  ButtonSize,
  ShowIcon,
} from '@uikit/components/Button/consts';
import Clickable from '@uikit/components/Clickable/Clickable';
import { ClickableAction } from '@uikit/components/Clickable/consts';
import Icon from '@uikit/components/Icon/Icon';
import PageHeader from '@uikit/components/NewHeader/PageHeader/PageHeader';
import clsx from 'clsx';
import styles from './MagazineArticleHeaderTitle.module.scss';
import { MagazineArticleHeaderTitleProps } from './types';

const MagazineArticleHeaderTitle = ({
  activatorProps,
  category = 'our-world',
  categorySlug,
  categoryTitle,
  hasBackground,
  hasTranslucentBackground,
  title,
}: MagazineArticleHeaderTitleProps) => {
  const isMobile = useIsMobile(BreakPoint.SM);

  return (
    <MagazineContextProvider value={{ currentCategory: category }}>
      <div
        className={clsx(styles.container, {
          [styles.hasTranslucentBackground]:
            hasBackground ||
            hasTranslucentBackground ||
            activatorProps.isActive,
        })}
      >
        {isMobile ? (
          <div className={styles.base}>
            <Button
              actionType={ClickableAction.Linkintern}
              className={styles.button}
              clickContext="Page Header"
              color={ButtonColor.Primary}
              icon="action/arrow-left"
              linkintern="/magazin"
              showIcon={ShowIcon.ShowIcon}
              size={ButtonSize.Small}
            >
              Übersicht
            </Button>

            {activatorProps.isEnabled && (
              <div
                className={styles.activatorContainer}
                {...PREVENT_DISMISS_PROP}
              >
                <Button
                  actionType={ClickableAction.Custom}
                  className={clsx(styles.button, styles.activator, {
                    [styles.isActive]: activatorProps.isActive,
                  })}
                  color={ButtonColor.Primary}
                  onClick={activatorProps.onClick}
                  size={ButtonSize.Small}
                >
                  <span className={styles.activatorContent}>
                    <span>Inhalt</span>
                    <Icon
                      aria-hidden="true"
                      className={styles.activatorChevron}
                      size="iconSize18"
                      variant="action/chevron-down"
                    />
                  </span>
                </Button>
              </div>
            )}
          </div>
        ) : (
          <nav aria-label="Breadcrumb" className={styles.base}>
            <Clickable
              actionType={ClickableAction.Linkintern}
              className={styles.magazineText}
              linkintern="/magazin"
            >
              Magazin
            </Clickable>

            <Icon
              className={styles.magazineChevron}
              size="iconSize20"
              variant={'action/chevron-right'}
            />

            <Clickable
              actionType={ClickableAction.Linkintern}
              className={styles.categoryText}
              linkintern={categorySlug}
            >
              #{categoryTitle}
            </Clickable>

            <Icon
              className={styles.categoryChevron}
              size="iconSize20"
              variant={'action/chevron-right'}
            />

            <PageHeader.Activator
              isActive={activatorProps.isActive}
              isEnabled={activatorProps.isEnabled}
              isInverted
              onClick={activatorProps.onClick}
              title={title}
            >
              {title}
            </PageHeader.Activator>
          </nav>
        )}
      </div>
    </MagazineContextProvider>
  );
};

export default MagazineArticleHeaderTitle;
